import { c as _c } from "react/compiler-runtime";
import { IcoFileText24 } from '@onefootprint/icons';
import type { DocumentKind } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
import type { EntityVault } from '@/types/vault';
import useDataLabelText from '../../hooks/use-data-label-text';
import getDataValue from '../../utils/get-data-value';
import getRelevantDocumentKeys from '../../utils/get-relevant-document-keys';
import CollapsibleSection from '../collapsible-section';
export type ExtractedDocumentDataProps = {
  vault: EntityVault;
  documentType: DocumentKind;
  activeDocumentVersion: string;
};
const ExtractedDocumentData = t0 => {
  const $ = _c(27);
  const {
    vault,
    documentType,
    activeDocumentVersion
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "fieldset.documents.details.ocr"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const dataLabelT = useDataLabelText();
  let T0;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[1] !== activeDocumentVersion || $[2] !== dataLabelT || $[3] !== documentType || $[4] !== t || $[5] !== vault) {
    t7 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const relevantKeys = getRelevantDocumentKeys({
        vault,
        documentType,
        currentDocumentNumber: activeDocumentVersion
      });
      if (relevantKeys.length === 0) {
        t7 = null;
        break bb0;
      }
      T0 = CollapsibleSection;
      t4 = IcoFileText24;
      if ($[13] !== t) {
        t5 = t(_temp);
        $[13] = t;
        $[14] = t5;
      } else {
        t5 = $[14];
      }
      t6 = true;
      t2 = "flex flex-col gap-2 w-full";
      let t8;
      if ($[15] !== dataLabelT || $[16] !== vault) {
        t8 = key => {
          const vaultValue = vault[key];
          const value = getDataValue(vaultValue, key);
          return <div key={key} className="w-full flex justify-between gap-6"><p className="text-body-2 text-tertiary">{dataLabelT(key)}</p><p className="text-body-2 text-primary text-right" style={{
              overflowWrap: "anywhere",
              wordBreak: "break-word"
            }} title={value} data-dd-privacy="mask">{" "}{value}</p></div>;
        };
        $[15] = dataLabelT;
        $[16] = vault;
        $[17] = t8;
      } else {
        t8 = $[17];
      }
      t3 = relevantKeys.map(t8);
    }
    $[1] = activeDocumentVersion;
    $[2] = dataLabelT;
    $[3] = documentType;
    $[4] = t;
    $[5] = vault;
    $[6] = T0;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    T0 = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
    t5 = $[10];
    t6 = $[11];
    t7 = $[12];
  }
  if (t7 !== Symbol.for("react.early_return_sentinel")) {
    return t7;
  }
  let t8;
  if ($[18] !== t2 || $[19] !== t3) {
    t8 = <div className={t2}>{t3}</div>;
    $[18] = t2;
    $[19] = t3;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== T0 || $[22] !== t4 || $[23] !== t5 || $[24] !== t6 || $[25] !== t8) {
    t9 = <T0 icon={t4} title={t5} defaultOpen={t6}>{t8}</T0>;
    $[21] = T0;
    $[22] = t4;
    $[23] = t5;
    $[24] = t6;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  return t9;
};
export default ExtractedDocumentData;
function _temp($) {
  return $.title;
}